import { css } from "@emotion/react";

import RoleName from "./RoleName";
import SingleRoleDescription from "./SingleRoleDescription";
import { RoleProps } from "./types";
import ViewAll from "./ViewAll";

const Role = ({ roles }: RoleProps) => {
    const renderRoles = () => {
        const rolesExist = roles.length > 0;

        if (!rolesExist) {
            return "-";
        }

        const { name, description } = roles[0];
        const isSingleRole = roles.length === 1;

        return (
            <div
                css={css({
                    overflowX: "hidden"
                })}
            >
                <RoleName name={name} />

                {isSingleRole ? (
                    <SingleRoleDescription description={description} />
                ) : (
                    <ViewAll roles={roles} />
                )}
            </div>
        );
    };

    return renderRoles();
};

export default Role;
